import React from 'react';
import './Testimonials.css';

// --- Gold Star Rating Component ---
const RatingStars = ({ count = 5, size = 'md' }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} className={`tst-star ${i <= count ? 'tst-star-filled' : 'tst-star-outlined'}`}>
        ★
      </span>
    );
  }
  return <div className={`tst-stars tst-stars-${size}`}>{stars}</div>;
};

const StarBadgeIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#C98E32" stroke="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

// --- Icons for Stats Bar ---
const BigStarIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="#E29922" stroke="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const WrenchIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#E29922" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

const ClockIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#E29922" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const Testimonials = () => {
  return (
    <section className="tst-section" id="testimonials">
      <div className="tst-bg-dots tst-bg-dots-left" aria-hidden="true" />
      <div className="tst-bg-dots tst-bg-dots-right" aria-hidden="true" />
      <div className="tst-bg-glow" aria-hidden="true" />

      <div className="tst-container">
        {/* Header */}
        <header className="tst-header">
          <div className="tst-badge">
            <StarBadgeIcon />
            <span>CUSTOMERS</span>
          </div>
          <h2 className="tst-title">
            <span className="tst-title-main">What Our Clients</span>
            <span className="tst-title-gold"> Say</span>
          </h2>
          <div className="tst-heading-divider" aria-hidden="true">
            <div className="tst-divider-line" />
            <div className="tst-divider-diamond" />
            <div className="tst-divider-line" />
          </div>
          <p className="tst-subtitle">
            Join thousands of satisfied customers who trust us for DoorStep Maintenance & Repair.
          </p>
        </header>

        {/* Top Featured Row */}
        <div className="tst-featured-row">
          {/* Left: Featured Quote Card */}
          <div className="tst-quote-card">
            {/* Big opening quote marks */}
            <div className="tst-open-quote" aria-hidden="true">"</div>

            <p className="tst-quote-text">
              Booking was effortless, the technician arrived{' '}
              <span className="tst-hl">on time</span>, and my iPhone was repaired right at
              my doorstep. <span className="tst-hl">No hidden charges</span>,{' '}
              <span className="tst-hl">genuine parts</span>, and excellent service. I didn't
              even have to leave my home.
            </p>

            {/* Inline author row: avatar | name + role | divider | stars */}
            <div className="tst-featured-author">
              <div className="tst-avatar-ring">
                <img
                  src="/images/reviews/subodh.jpg"
                  alt="Rahul Verma"
                  className="tst-author-avatar"
                />
              </div>
              <div className="tst-author-info">
                <h4 className="tst-author-name">Rahul Verma</h4>
                <span className="tst-author-role">Verified Customer</span>
              </div>
              <div className="tst-author-divider" aria-hidden="true" />
              <RatingStars count={5} size="sm" />
            </div>
          </div>

          {/* Right: Featured Image */}
          <div className="tst-image-card">
            <div className="tst-image-frame">
              <img
                src="/images/reviews/featured.webp"
                alt="DSMR technician repairing device at customer's doorstep"
                className="tst-featured-img"
              />
            </div>
          </div>
        </div>

        {/* Bottom 3-Column Reviews Grid */}
        <div className="tst-reviews-grid">
          {/* Review 1 */}
          <div className="tst-card">
            <RatingStars count={5} />
            <p className="tst-review-body">
              My iPhone 14 display was replaced at my home in{' '}
              <span className="tst-hl">under 30 minutes</span>. The technician explained
              everything clearly and the repair was <span className="tst-hl">flawless</span>.
              Highly professional!
            </p>
            <div className="tst-author-box">
              <div className="tst-avatar-ring">
                <img src="/images/reviews/subodh.jpg" alt="Subodh Mehta" className="tst-author-avatar" />
              </div>
              <div className="tst-author-info">
                <h4 className="tst-author-name">Subodh Mehta</h4>
                <span className="tst-author-role">Verified Customer</span>
              </div>
            </div>
          </div>

          {/* Review 2 */}
          <div className="tst-card">
            <RatingStars count={5} />
            <p className="tst-review-body">
              My work laptop crashed during a tight deadline. The technician came the{' '}
              <span className="tst-hl">same day</span>, replaced the{' '}
              <span className="tst-hl">SSD</span> and{' '}
              <span className="tst-hl">optimized</span> everything. It's now faster than
              ever. A true lifesaver!
            </p>
            <div className="tst-author-box">
              <div className="tst-avatar-ring">
                <img src="/images/reviews/aishwarya.jpg" alt="Aishwarya Saxena" className="tst-author-avatar" />
              </div>
              <div className="tst-author-info">
                <h4 className="tst-author-name">Aishwarya Saxena</h4>
                <span className="tst-author-role">Verified Customer</span>
              </div>
            </div>
          </div>

          {/* Review 3 */}
          <div className="tst-card">
            <RatingStars count={5} />
            <p className="tst-review-body">
              My Galaxy S24 kept overheating and restarting often. The technician fixed it at
              my doorstep <span className="tst-hl">within an hour</span>. Quick, professional,
              and <span className="tst-hl">no hidden charges</span>. Highly recommended!
            </p>
            <div className="tst-author-box">
              <div className="tst-avatar-ring">
                <img src="/images/reviews/nidhi.jpg" alt="Nidhi Malhotra" className="tst-author-avatar" />
              </div>
              <div className="tst-author-info">
                <h4 className="tst-author-name">Nidhi Malhotra</h4>
                <span className="tst-author-role">Verified Customer</span>
              </div>
            </div>
          </div>
        </div>

        {/* Dark Mode Trust / Stats Bar */}
        <div className="tst-stats-bar">
          <div className="tst-stat-item">
            <div className="tst-stat-icon-box">
              <BigStarIcon />
            </div>
            <div className="tst-stat-info">
              <div className="tst-stat-value-group">
                <span className="tst-stat-val">4.6/5</span>
                <span className="tst-stat-lbl">Rating</span>
              </div>
              <span className="tst-stat-sub">From Google Maps Reviews</span>
            </div>
          </div>

          <div className="tst-stat-item">
            <div className="tst-stat-icon-box">
              <WrenchIcon />
            </div>
            <div className="tst-stat-info">
              <div className="tst-stat-value-group">
                <span className="tst-stat-val">12,000+</span>
              </div>
              <span className="tst-stat-sub">Devices Repaired</span>
            </div>
          </div>

          <div className="tst-stat-item">
            <div className="tst-stat-icon-box">
              <ClockIcon />
            </div>
            <div className="tst-stat-info">
              <div className="tst-stat-value-group">
                <span className="tst-stat-val">90%</span>
              </div>
              <span className="tst-stat-sub">Same-Day Repairs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
